export default (value) => value.replace(/^\/+/, '');
